<template>
  <div>
    <DxToolbar class="split-view-toolbar">
      <dx-item
        location="before"
        widget="dxTabs"
        :options="filterPanelTabOptions"
        :selected-index.sync="sidebarTabSelectedIndex"
      ></dx-item>

      <DxItem :options="toolbar.close" location="after" widget="dxButton" />
    </DxToolbar>

    <div v-show="sidebarTabSelectedIndex == 0">
      <div class="view-card responsive-paddings">
        <div class="advance-filter-header-btns">
          <DxButton
            class="apply-btn"
            :text="applyButtonLabel"
            type="default"
            @click="applyFilter"
          />
          <DxButton text="clear" type="normal" @click="clearFilter" />
        </div>

        <div class="filter-form">
          <DxForm
            id="form"
            :items="getItems"
            :ref="'storageLocationFilterForm'"
            labelLocation="top"
            :showColonAfterLabel="false"
            @content-ready="onContentReady"
            :height="getFilterFormHeight"
            @fieldDataChanged="fieldDataChanged"
          >
            <template #Record="{ data }">
              <GcRecord
                :data="{ data: data }"
                :primary="data['cellTemplateRecord']['primary']"
                :secondary="data['cellTemplateRecord']['secondary']"
              />
            </template>
          </DxForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductService } from "../../_services/api/products/product.service";
import appConfig from "../../app-config";

export default {
  props: {
    toolbar: {
      type: Object,
      default: () => {},
    },
    heightAdjustment: {
      type: Number,
      default: 0,
    },
    setGridPanelFilter: {
      type: Function,
      default: () => function () {},
    },
    persistanceKey: {
      type: String,
      default: "gc-bin_list-filter-panel",
    },
  },
  data() {
    return {
      sidebarTabSelectedIndex: 0,
      dirty: {
        isDirty: false,
      },
      filterCollection: [],
      formDataElement: undefined,
      getFormData: {
        Branch: null,
        SiteRecordId: null,
        BuildingRecordId: null,
        AreaRecordId: null,
        AisleRecordId: null,
        BayRecordId: null,
        SpaceRecordId: null,
        ShelfRecordId: null,
      },
    };
  },
  mounted() {
    let storedFilters = localStorage.getItem(
      this.getPersistanceKey + "_filterCollection"
    );

    if (storedFilters) {
      var parsedFilters = JSON.parse(storedFilters);
      this.filterCollection = parsedFilters;
      this.setGridPanelFilter(this.filterCollection, true);
    } else {
      this.filterCollection = [];
    }
    let formData = localStorage.getItem(this.getPersistanceKey + "_formData");
    if (formData) {
      let storedFormData = JSON.parse(formData);
      var form = this.$refs.storageLocationFilterForm.instance;
      if (form && storedFormData) {
        [
          "SiteRecordId",
          "BuildingRecordId",
          "AreaRecordId",
          "AisleRecordId",
        ].forEach((item) => {
          if (storedFormData[item]) {
            form.getEditor(item).option("value", storedFormData[item]);
          }
        });
      }
    } else {
      this.resetModel();
    }
  },
  methods: {
    fieldDataChanged() {
      this.dirty.isDirty = false;
    },
    onContentReady(e) {
      this.formDataElement = e.component;
    },
    applyFilter() {
      this.dirty.isDirty = true;
      localStorage.setItem(
        this.getPersistanceKey + "_filterCollection",
        JSON.stringify(this.filterCollection)
      );
      localStorage.setItem(
        this.getPersistanceKey + "_formData",
        JSON.stringify(this.getFormData)
      );
      this.setGridPanelFilter(this.filterCollection, true);
    },
    clearFilter() {
      this.dirty.isDirty = false;
      localStorage.setItem(this.getPersistanceKey + "_filterCollection", []);
      localStorage.setItem(this.getPersistanceKey + "_formData", null);

      this.resetModel();
      // // this.filterCollection = [];
      var form = this.$refs.storageLocationFilterForm.instance;
      [
        "SiteRecordId",
        "BuildingRecordId",
        "AreaRecordId",
        "AisleRecordId",
      ].forEach((item) => {
        form.getEditor(item).option("value", null);
      });

      this.setGridPanelFilter([], false);
    },
    resetModel() {
      this.getFormData.Branch = null;
      this.getFormData.SiteRecordId = null;
      this.getFormData.BuildingRecordId = null;
      this.getFormData.AreaRecordId = null;
      this.getFormData.AisleRecordId = null;
      this.getFormData.BayRecordId = null;
      this.getFormData.SpaceRecordId = null;
      this.getFormData.ShelfRecordId = null;
    },
    setFilterValues(filter, dataField) {
      if (this.filterCollection.length > 0) {
        let index = this.filterCollection.findIndex(
          (x) => x[0][0] == dataField
        );
        if (index > -1) {
          if (this.filterCollection[index + 1] == "and") {
            this.filterCollection.splice(index, 2);
          } else {
            this.filterCollection.splice(index, 1);
          }
        }
        // after the splice event

        if (
          this.filterCollection.length > 0 &&
          this.filterCollection[this.filterCollection.length - 1] != "and"
        )
          this.filterCollection.push("and");
      }

      if (filter && filter.length > 0) {
        this.filterCollection.push(filter);
      }

      if (this.filterCollection[this.filterCollection.length - 1] == "and") {
        this.filterCollection.splice(this.filterCollection.length - 1, 1);
      }
    },
    rePaintBuildingElement(element) {
      const form = this.f;
      if (form) {
        const item = form.getEditor(element);
        if (item) {
          item.reset();
          item.option(
            "dataSource",
            ProductService.dataSourceConfig("api/BuildingList", {
              filter: [["SiteRecordId", "=", this.getFormData.SiteRecordId]],
              sort: [{ selector: "Building", asc: true }],
              keyType: {
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
              // key: "BuildingRecordId",
              fieldType: {
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
            })
          );
        }
      }
    },
    rePaintAreaElement(element) {
      const form = this.formDataElement;
      if (form) {
        const item = form.getEditor(element);
        if (item) {
          item.reset();
          item.option(
            "dataSource",
            ProductService.dataSourceConfig("api/AreaList", {
              filter: [
                ["BuildingRecordId", "=", this.getFormData.BuildingRecordId],
                "and",
                ["SiteRecordId", "=", this.getFormData.SiteRecordId],
              ],
              sort: [{ selector: "Area", asc: true }],
              keyType: {
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
              // key: "AreaRecordId",
              fieldType: {
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
            })
          );
        }
      }
    },
    rePaintAisleElement(element) {
      const form = this.formDataElement;
      if (form) {
        const item = form.getEditor(element);
        if (item) {
          item.reset();
          item.option(
            "dataSource",
            ProductService.dataSourceConfig("api/AisleList", {
              filter: [
                ["AreaRecordId", "=", this.getFormData.AreaRecordId],
                "and",
                ["BuildingRecordId", "=", this.getFormData.BuildingRecordId],
                "and",
                ["SiteRecordId", "=", this.getFormData.SiteRecordId],
              ],
              sort: [{ selector: "Aisle", asc: true }],
              keyType: {
                AisleRecordId: "Guid",
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
              // key: "AisleRecordId",
              fieldType: {
                AisleRecordId: "Guid",
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
            })
          );
        }
      }
    },
    onSiteRecordIdValueChanged(e) {
      let filter = [];
      let dataField = "SiteRecordId";
      if (e.value) {
        filter.push([dataField, "=", e.value]);
        this.getFormData.SiteRecordId = e._value
          ? e._value
          : e.value
          ? e.value
          : null;
      } else {
        this.getFormData.SiteRecordId = null;
      }
      this.setFilterValues(filter, dataField);
      this.rePaintBuildingElement("BuildingRecordId");
    },
    onBuildingRecordIdValueChanged(e) {
      let filter = [];
      let dataField = "BuildingRecordId";
      if (e.value) {
        filter.push([dataField, "=", e.value]);
        this.getFormData.BuildingRecordId = e._value
          ? e._value
          : e.value
          ? e.value
          : null;
      } else {
        this.getFormData.BuildingRecordId = null;
      }
      this.setFilterValues(filter, dataField);
      this.rePaintAreaElement("AreaRecordId");
    },
    onAreaRecordIdValueChanged(e) {
      let filter = [];
      let dataField = "AreaRecordId";
      if (e.value) {
        filter.push([dataField, "=", e.value]);
        this.getFormData.AreaRecordId = e._value
          ? e._value
          : e.value
          ? e.value
          : null;
      } else {
        this.getFormData.AreaRecordId = null;
      }
      this.setFilterValues(filter, dataField);
      this.rePaintAisleElement("AisleRecordId");
    },
    onAisleRecordIdValueChanged(e) {
      if (!e.value) return;
      let filter = [];
      let dataField = "AisleRecordId";

      if (e.value) {
        filter.push([dataField, "=", e.value]);
        this.getFormData.AisleRecordId = e._value
          ? e._value
          : e.value
          ? e.value
          : null;
      } else {
        this.getFormData.AisleRecordId = null;
      }

      this.setFilterValues(filter, dataField);
    },
  },
  computed: {
    getPersistanceKey() {
      return this.persistanceKey + "_" + appConfig.VUE_APP_COOKIE_NAME;
    },
    getFilterFormHeight() {
      return this.heightAdjustment - 93;
    },
    filterPanelTabOptions() {
      return {
        dataSource: [
          {
            id: 0,
            text: "Filters",
          },
        ],
        selectedIndex: this.sidebarTabSelectedIndex,
      };
    },
    applyButtonLabel() {
      if (this.dirty.isDirty) {
        return "Refresh";
      } else {
        return "Apply";
      }
    },
    getItems() {
      return [
        {
          // screenField: "ColumnValue",
          dataField: "SiteRecordId",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig("api/SiteList", {
              sort: [{ selector: "Site", asc: true }],
              keyType: {
                SiteRecordId: "Guid",
              },
              // key: "SiteRecordId",
              fieldType: {
                SiteRecordId: "Guid",
              },
            }),
            valueExpr: "SiteRecordId",
            displayExpr: "Site",
            searchEnabled: true,
            showClearButton: true,
            onValueChanged: (e) => {
              this.onSiteRecordIdValueChanged(e);
            },
          },
          label: {
            text: "Site",
          },
        },
        {
          dataField: "BuildingRecordId",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig("api/BuildingList", {
              filter: [["SiteRecordId", "=", this.getFormData.SiteRecordId]],
              sort: [{ selector: "Building", asc: true }],
              keyType: {
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
              // key: "BuildingRecordId",
              fieldType: {
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
            }),
            valueExpr: "BuildingRecordId",
            displayExpr: "Building",
            searchEnabled: true,
            showClearButton: true,
            onValueChanged: (e) => {
              this.onBuildingRecordIdValueChanged(e);
            },
          },
          label: {
            text: "Building",
          },
        },
        {
          dataField: "AreaRecordId",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig("api/AreaList", {
              filter: [
                ["BuildingRecordId", "=", this.getFormData.BuildingRecordId],
                "and",
                ["SiteRecordId", "=", this.getFormData.SiteRecordId],
              ],
              sort: [{ selector: "Area", asc: true }],
              keyType: {
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
              // key: "AreaRecordId",
              fieldType: {
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
            }),
            valueExpr: "AreaRecordId",
            displayExpr: "Area",
            searchEnabled: true,
            showClearButton: true,
            onValueChanged: (e) => {
              this.onAreaRecordIdValueChanged(e);
            },
          },
          label: {
            text: "Area",
          },
        },
        {
          dataField: "AisleRecordId",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig("api/AisleList", {
              filter: [
                ["AreaRecordId", "=", this.getFormData.AreaRecordId],
                "and",
                ["BuildingRecordId", "=", this.getFormData.BuildingRecordId],
                "and",
                ["SiteRecordId", "=", this.getFormData.SiteRecordId],
              ],
              sort: [{ selector: "Aisle", asc: true }],
              keyType: {
                AisleRecordId: "Guid",
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
              // key: "AisleRecordId",
              fieldType: {
                AisleRecordId: "Guid",
                AreaRecordId: "Guid",
                BuildingRecordId: "Guid",
                SiteRecordId: "Guid",
              },
            }),
            valueExpr: "AisleRecordId",
            displayExpr: "Aisle",
            searchEnabled: true,
            showClearButton: true,
            onValueChanged: (e) => {
              this.onAisleRecordIdValueChanged(e);
            },
          },
          label: {
            text: "Aisle",
          },
        },
      ];
    },
  },
};
</script>
